module.exports = __webpack_public_path__ + "static/media/from-stairs.111bc9f3.jpg";